<template>
  <div class="container mx-auto">
    <h1 v-if="session">
      <span class="font-bold text-xl">{{ session.title }}</span>
      <span class="text-xs">{{ session.date | formatDate }}</span>
    </h1>

    <p v-bind="session.description" />

    <div
      class="mb-2 section-title mt-8 flex flex-row cursor-pointer"
      @click="exExpanded=!exExpanded"
    >
      <div class="flex-grow">
        {{ session.exercises.length }} Übungen
      </div>
      <div>
        <i
          v-if="exExpanded"
          class="fas fa-angle-double-up"
        />
        <i
          v-if="!exExpanded"
          class="fas fa-angle-double-down"
        />
      </div>
    </div>
    <div
      v-if="exExpanded"
      class="flex flex-col"
    >
      <div
        v-for="exercise in session.exercises"
        :key="exercise.shortKey"
        class="pb-2 mb-4"
      >
        <div class="flex flex-row">
          <div class="flex  flex-col mr-4 items-center text-gray-400">
            <i
              :class="{ 'text-green-600': isUpVoted(exercise)}"
              class="far fa-3x fa-smile-beam hover:text-green-600 mb-8"
              @click="rate(exercise.shortKey,1)"
            />

            <i
              :class="{ 'text-red-600': isDownVoted(exercise)}"
              class="far fa-3x fa-frown hover:text-red-600"
              @click="rate(exercise.shortKey,-1)"
            />
          </div>

          <sc-exercise-small
            :key="exercise.shortKey"
            :title="exercise.name"
            :image="exercise.assets[0]"
            :short-key="exercise.shortKey"
            :tags="exercise.tags"
          />

          <div class="flex flex-col flex-grow">
            <textarea
              id="inline-full-name"
              placeholder="Feedback eintragen"
              class=" flex-grow bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-500"
              type="text"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="mb-2  bg-green-600 text-white p-2 mt-8">
      Spieler
    </div>

    <div>
      <div class="flex flex-row mb-4 font-bold">
        <div class="w-32">
          Name
        </div>
        <div class="w-32">
          Verspätet (Minuten)
        </div>
        <div class="w-32">
          Verwarnungen
        </div>

        <div class="w-32">
          Anmerkungen
        </div>
      </div>

      <div
        v-for="review in session.playerReviews"
        :key="review.player.id"
        class="flex flex-row mb-4"
      >
        <div class="w-32">
          {{ review.player.name }}
        </div>

        <div class="w-32">
          <input
            class="w-16 bg-gray-200 appearance-none border-2 border-gray-200 rounded py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-500"
            type="text"
            value="0"
          >
        </div>

        <div class="flex flex-row w-32">
          <div
            :class="{ 'bg-yellow-600': hasYellow(review)}"
            class="rounded cursor-pointer h-8 w-6 border-black border-2 bg-white hover:bg-yellow-600 mr-2"
            @click="setCaution(review.player,1)"
          />
          <div
            :class="{ 'bg-red-700': hasRed(review)}"
            class="rounded cursor-pointer h-8 w-6 border-black border-2 hover:bg-red-700 mr-2"
            @click="setCaution(review.player,2)"
          />
        </div>

        <div class="flex-grow">
          <input
            class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-500"
            type="text"
          >
        </div>
        <div>
          <i class="fas fa-2x fa-cloud-upload-alt cursor-pointer text-green-700" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '../api/apiService'

export default {
    name: 'TrainingFeedbackVue',
    data () {
        return {
            exExpanded: true,
            session: null,
            id: null
        }
    },
    async mounted () {
        const id = this.$route.params.id
        this.id = id
        const response = await apiService.getSsession(id)
        this.session = response.data
    },
    methods: {
        hasRed (review) {
            var result = review.caution === 2
            return result
        },
        hasYellow (review) {
            return review.caution === 1
        },
        isUpVoted (exercise) {
            if (exercise) {
                var found = false
                for (var i = 0; i < this.session.currentUserUpVotes.length; i++) {
                    if (this.session.currentUserUpVotes[i] === exercise.shortKey) {
                        found = true
                        break
                    }
                }
                return found
            } else {
                return false
            }
        },
        isDownVoted (exercise) {
            if (exercise) {
                var found = false
                for (var i = 0; i < this.session.currentUserDownVotes.length; i++) {
                    if (this.session.currentUserDownVotes[i] === exercise.shortKey) {
                        found = true
                        break
                    }
                }
                return found
            } else {
                return false
            }
        },
        async setCaution (member, caution) {
            var review = this.session.playerReviews.find(x => x.player.id === member.id)
            console.log(review)
            if (review.caution === caution) {
                caution = 0
            }
            review.caution = caution
            await apiService.setPlayerCaution(this.session.id, member.id, caution)
        },
        async rate (exShortKey, rating) {
            await apiService.rateExerciseOfSession(this.id, exShortKey, rating)

            const response = await apiService.getSsession(this.id)
            this.session = response.data
        },
        async firstAsset (exercise) {
            if (exercise && exercise.assets && exercise.assets.length > 0) {
                return exercise.assets[0]
            } else {
                return ''
            }
        }
    }
}
</script>

<style scoped>

</style>